import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../../Header';
import {TimerLines} from '../TimerImages';
import className from '../style.module.scss';
import {Modal, Button} from '@learningblocks/storybook-components';

export function TimerPopup(props) {
  const renderFooter = () => {
    if (props.skipTimer) {
      return [
        <p key='0' className={className.text}>
          Note: You don't have to watch the full animation.
        </p>,
        <Button
          key='1'
          className={className.button}
          onClick={props.onFooterClick}>
          Skip Ahead
        </Button>,
      ];
    } else {
      return (
        <Button className={className.button} onClick={props.onFooterClick}>
          Done
        </Button>
      );
    }
  };

  return (
    <Modal isOpen={props.isOpen} className={className.timerModal}>
      <div onClick={(e)=>e.stopPropagation()}>
        <Header
          className={className.timerModalHead}
          label='SET THE TIMER'
          close={props.onClose}
          size={props.size}
        />
        <div className={className.section}>
          <div className={className.sectionLeft}>
            <TimerLines className={className.icon} />
            <p className={className.text}>Set the timer</p>
          </div>
          <div className={className.sectionRight}>{props.children}</div>
        </div>
        <div className={className.footer}>{renderFooter()}</div>
      </div>
    </Modal>
  );
}

TimerPopup.propTypes = {
  /**
   * Boolen to set if popup is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback to close Modal window
   */
  onClose: PropTypes.func,
  /**
   * TimerControl Component
   */
  children: PropTypes.element,
  /**
   * Boolean to show/hide SkipAhead Button and Message
   */
  skipTimer: PropTypes.bool,
  /**
   * Callback function for Footer button
   */
  onFooterClick: PropTypes.func,
};

TimerPopup.defaultProps = {
  size: 'md',
  skipTimer: undefined,
};
